import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const isDev = typeof window !== 'undefined' && window.location?.hostname === 'localhost';

const getVideoUrls = async (filenames) => {
  const baseUrl = isDev ? 'http://localhost:3500' : '';
  const requests = filenames.map(filename =>
    axios
      .get(`${baseUrl}/api/azure-stream?fileName=${filename}`)
      .then(resp => resp.data)
      .catch(error => {
        console.error(`Failed to fetch video stream for ${filename}:`, error);
        return null;
      })
  );

  return Promise.all(requests).then(urls => urls.filter(url => url));
};


const SectionGallery = props => {
  const { listing, outOfStockImage, onFullScreenChange } = props;
  const images = listing?.images;
  const videoFilenames = listing?.attributes?.publicData?.videos || [];

  const [videoUrls, setVideoUrls] = useState([]);

  useEffect(() => {
    if (videoFilenames.length > 0) {
      getVideoUrls(videoFilenames).then(urls => setVideoUrls(urls));
    }
  }, [videoFilenames]);

  const { variantPrefix } = config.listing;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <ListingImageGallery
      rootClassName={css.productGallery}
      images={images}
      videos={videoUrls}
      imageVariants={imageVariants}
      thumbnailVariants={thumbnailVariants}
      listing={listing}
      outOfStockImage={outOfStockImage}
      onFullScreenChange={onFullScreenChange}
    />
  );
};

export default SectionGallery;
